import { useState } from 'react'
import { Paper, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ContentTitle } from '../components/common/ContentTitle'
import { ActionAlert } from '../components/dialogs/ActionAlert'
import { ActionFailedAlert } from '../components/dialogs/ActionFailedAlert'
import { BasicLayout } from '../components/layouts/BasicLayout'
import { InstrumentTableFilters } from '../components/InstrumentList/InstrumentTableFilters'
import { InstrumentTableHeader } from '../components/InstrumentList/InstrumentTableHeader'
import { InstrumentTableBody } from '../components/InstrumentList/InstrumentTableBody'
import { TransparentIconButton } from '../components/common/TransparentIconButton'
import AppsIcon from '@mui/icons-material/AppsRounded'
import { Pages } from '../router/router'
import { useHistory } from 'react-router-dom'
import ImportExportIcon from '@mui/icons-material/ImportExportRounded'
import { OrderInputDialog } from '../components/dialogs/OrderInputDialog'
import { InstrumentInputDialog } from '../components/dialogs/InstrumentInputDialog'
import { FileImportDialog } from '../components/dialogs/FileImportDialog'
import { useTranslation } from 'react-i18next'
import CardWrapper from '../components/common/CardWrapper'
import { NewLayout } from '../components/newLayout/NewLayout'
import { tokens } from '../styles/tokens'

const useStyles = makeStyles(theme => ({
  orderDisplayPanel: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexGrow: 1,
  },
  orderDisplayTable: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    flexGrow: 1,
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
  },

  clientEssentials: {
    width: '25%',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
  },
  manIcon: {
    marginTop: theme.spacing(1),
  },
  clientPersonalInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1),
  },
  test: {
    background: 'red',
    width: '200px',
    position: 'absolute',
    top: '20px',
    left: '-50px',
    opacity: '0.95',
    textAlign: 'center',
    lineHeight: '25px',
    fontSize: '16px',
    letterSpacing: '1px',
    color: '#f0f0f0',
    transform: 'rotate(-45deg)',
    paddingRight: '18px',
  },
  table: {
    marginTop: theme.spacing(2),
  },
  sectionHeader: {
    background: `linear-gradient(135deg, ${tokens.color.primary[800]}, ${tokens.color.primary[600]})`,
    margin: '-16px -16px 16px',
    padding: '12px 16px',
    borderRadius: `${tokens.radius.lg} ${tokens.radius.lg} 0 0`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    minHeight: '48px',
  },
  sectionHeaderTitle: {
    color: tokens.color.white,
    fontSize: '0.9375rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
}))

const ribon = process.env.REACT_APP_ENV_RIBBON

export const InstrumentList = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()
  const [isUpdate, setIsUpdate] = useState(false)
  // Duplikace instrumentu: dialog se predvyplni ze stavajiciho zaznamu,
  // ale ulozi se jako novy (sef zaklada stejne instrumenty s jinym trhem).
  const [isDuplicate, setIsDuplicate] = useState(false)

  return (
    <NewLayout pageName={t('INSTRUMENT_OVERVIEW')}>
      <InstrumentTableFilters setIsUpdate={setIsUpdate} setIsDuplicate={setIsDuplicate} />
      <CardWrapper className={classes.table}>
        <div className={classes.sectionHeader}>
          <p className={classes.sectionHeaderTitle}>{t('EVIDENCE_INSTRUMENTS')}</p>
        </div>
        <InstrumentTableBody setIsUpdate={setIsUpdate} setIsDuplicate={setIsDuplicate} />
      </CardWrapper>
      <ActionAlert />
      <ActionFailedAlert handleClose={()=>{}}/>
      <InstrumentInputDialog isUpdate={isUpdate} isDuplicate={isDuplicate} />
      <FileImportDialog />
      {/* <OrderInputDialog client={null} portfolio={null}/> */}
    </NewLayout>
  )
}
